export default {
  cockpitManage: {
    completed2: 'Completed',
    uncompleted3: 'Incomplete',
    indicator7: 'Metric',
    orderCount8: 'Orders',
    visitCount9: 'Visits',
    commitmentCount10: 'Scheduled Visits',
    wechatCount11: 'WeChat Adds',
    callCount12: 'Calls',
    quantity13: 'Quantity',
    channelProportion14: 'Channel Share',
    channelConversion16: 'Channel Conversion Rate',
    startDate17: 'Start Date',
    endDate18: 'End Date',
    dashboard49: 'Dashboard',
    currentTimeProgress50: 'Time Progress',
    performanceCompletion51: 'Performance Completion',
    learningRevenue52: 'Learning Tablet Revenue',
    target53: 'Target',
    channelConversionOverview56: 'Channel Conversion Overview',
    processMetrics57: 'Process Metrics',
    funnelMetrics58: 'Funnel Metrics',
    clueCall59: 'Lead Calls',
    callWechat60: 'Call → WeChat',
    wechatCommitment61: 'WeChat → Scheduled Visit',
    commitmentVisit62: 'Scheduled Visit → Visit',
    visitConversion63: 'Visit Conversion',
    salesPerformanceProgress64: 'Sales Performance Progress',
    redBelowTimeProgress65: 'Red indicates performance is behind time progress',
    salesFollowUpStats66: 'Cumulative Sales Follow-up Stats',
    remindSalesDaily67: 'Remind sales staff to submit daily reports via the DingTalk workspace',
    statsDate68: 'Report Date',
    selectMonth69: 'Select Month',
    selectDatePlaceholder: 'Select Date',
    targetParamsSetting: 'Target Parameter Settings',
    avgPriceLabel: 'Average Price',
    conversionRate: 'Conversion Rate',
    visitRate: 'Visit Rate',
    promiseVisitRate: 'Scheduled Visit Rate',
    addWechatRate: 'WeChat Add Rate',
    supervisorNewSignRate: 'Instructor Conversion Rate',
    supervisorAvgPrice: 'Instructor Avg. Price',
    enterAvgPrice: 'Enter average price',
    enterConversionRate: 'Enter conversion rate',
    enterVisitRate: 'Enter visit rate',
    enterPromiseVisitRate: 'Enter scheduled visit rate',
    enterAddWechatRate: 'Enter WeChat add rate',
    enterSupervisorNewSignRate: 'Enter instructor conversion rate',
    enterSupervisorAvgPrice: 'Enter instructor average price',
    edit: 'Edit',
    save: 'Save',
    reset: 'Reset',
    yuan: '$',
    reportReminderSettings: 'Report Reminder Settings',
    reminderTime: 'Reminder Time',
    everyday: 'Daily',
    reminderDescription: 'Send task reminders via DingTalk to staff who need to submit reports',
    timesUnit: ' times',
    tip1: "The default average price is based on last month's retail price average of all Learning Tablets sold",
    tip2: 'If no Learning Tablets were sold last month, the national average price is used',
    tip3: 'Default conversion, visit, scheduled visit, WeChat add rates, and instructor metrics are based on industry benchmarks',
    tip4: 'All parameters can be customized. Changes apply to targets not yet started',
    tip5: 'Click Reset to restore default values. Changes apply to targets not yet started',
    targetManagement: 'Target Management',
    noTargetThisMonthTip: 'No target set for this month yet. Add one now',
    newTarget: 'New Target',
    addTarget: 'Add Target',
    monthlyTarget: 'Monthly Target',
    selfBuilt: 'Self-created',
    superior: 'From Manager',
    targetRevenue: 'Target Revenue',
    currentRevenue: 'Current Revenue',
    actualRevenue: 'Actual Revenue',
    completion: 'Completion Rate',
    timeProgress: 'Time Progress',
    notStarted: 'Not Started',
    remainingDays: '{days} days remaining',
    view: 'View',
    delete: 'Delete',
    operationReminder: 'Action Reminder',
    deleteTargetConfirmTip: 'Deleting this target will reset all submitted performance data and associated sales targets. Continue with caution',
    exit: 'Exit',
    targetDetail: 'Target Details',
    targetSetting: 'Target Settings',
    targetCycle: 'Target Cycle',
    selectMonthPlaceholder: 'Select Month',
    superiorAddedTargetTip: 'Your manager has assigned a target for this month. You may allocate it as needed',
    learningMachinePart: 'Learning Tablet Segment',
    supervisorPart: 'Instructor Segment',
    estimatedRevenue: 'Estimated Revenue',
    estimateBasedOnOfficialRetailPrice: 'Estimated based on official retail price',
    model: 'Model',
    targetUnits: 'Target Units',
    totalTargetRevenue: 'Total Target Revenue',
    promoteTarget: 'Increase Target',
    myTarget: 'My Target',
    supervisorIncomeDefaultTip: 'Instructor revenue defaults to Learning Tablet unit count',
    supervisorNewSignRateTip1: 'Instructor conversion rate and pricing can be adjusted',
    supervisorNewSignRateTip2: 'in system settings,',
    supervisorNewSignRateTip3: 'or you may directly input expected revenue',
    totalRevenue: 'Total Revenue',
    nextStepAssignTarget: 'Next: Assign Targets',
    smartAssignedTip: 'Targets have been auto-assigned based on your settings. Adjust Learning Tablet / Instructor targets as needed',
    targetSource: 'Target Source',
    selfBuiltTarget: 'Self-created Target',
    superiorAgent: 'Manager',
    addStaff: 'Add Staff',
    ratioMode: 'Ratio Mode',
    revenueMode: 'Revenue Mode',
    restoreDefaultPlan: 'Restore Default Plan',
    learningRevenueRatio: 'Learning Tablet Revenue Ratio',
    learningRevenue: 'Learning Tablet Revenue',
    supervisorRevenueRatio: 'Instructor Revenue Ratio',
    supervisorRevenue: 'Instructor Revenue',
    totalTarget: 'Total Target',
    targetBreakdown: 'Target Breakdown',
    total: 'Total',
    backToTargetSetting: 'Back to Target Settings',
    confirmModify: 'Confirm Changes',
    complete: 'Complete',
    select: 'Select',
    name: 'Name',
    staffRole: 'Role',
    tipTitle: 'Notice',
    switchModeConfirmTip: 'Are you sure you want to switch modes?',
    switchModeImpactTip: 'All staff revenue ratios will be recalculated',
    restoreDefaultTip1: 'Staff changes detected. Revenue ratios will be reset to default',
    restoreDefaultTip2: 'All staff ratios will be recalculated',
    salesName: 'Sales Name',
    assignRatio: 'Assigned Ratio',
    revenueTarget: 'Revenue Target',
    processTarget: 'Process Target',
    processTargetTip: 'Process targets are auto-calculated. Adjust parameters in system settings if needed',
    iKnow: 'Got it',
    submitTargetConfirmPrefix: 'After submission, targets will be assigned and will take effect on ',
    submitTargetConfirmSuffix: '. Continue?',
    deleteStaffImpactTip: 'Removing staff will reset their targets and associated sales targets. Proceed with caution',
    pleaseEnterLearningTarget: 'Enter Learning Tablet target',
    pleaseEnterSupervisorTarget: 'Enter Instructor target',
    previousMonthTargetLabel: 'Last Month Target: ',
    actualCompletedLabel: 'Actual Completion: ',
    staffAddedCount: '{count} staff added',
    actualRevenueLabel: 'Actual Revenue: ',
    targetRevenueLabel: 'Target Revenue: ',
    currentRevenueLabel: 'Current Revenue: ',
    effectiveDate: '{year}-{month}-01',
    learningMachinePartPrefix: 'Learning Tablet:',
    supervisorPartPrefix: 'Instructor:',
    estimatedTargetPrefix: 'Estimated Target ',
    targetPrefix: 'Target ',
    learningMachinePartWithDash: 'Learning Tablet - ',
    myLearningRevenueNotBelow: 'Learning Tablet revenue must be at least {amount}',
    mySupervisorRevenueNotBelow: 'Instructor revenue must be at least {amount}',
  },
  cockpit: {
    resultOutcome: 'Outcome Metrics',
    processOutcome: 'Process Metrics',
    workSpotCheck: 'Work Spot Check',
    statsDate: 'Report Date',
    staffName: 'Staff Name',
    reportDate: 'Report Date',
    salesPerson: 'Sales Representative',
    date: 'Date',
    totalAmount: 'Total Revenue',
    totalTarget: 'Total Target',
    totalTargetCompletion: 'Total Target Completion',
    learningMachineAmount: 'Learning Tablet Revenue',
    learningMachineTarget: 'Learning Tablet Target',
    learningMachineCompletion: 'Learning Tablet Target Completion',
    supervisorAmount: 'Instructor Revenue',
    supervisorTarget: 'Instructor Target',
    supervisorCompletion: 'Instructor Target Completion',
    supervisorNewSign: 'New Instructor Revenue',
    supervisorRenew: 'Instructor Renewal Revenue',
    clueNum: 'Number of Leads',
    clueNumShort: 'Leads',
    callNum: 'Calls',
    callTarget: 'Call Target',
    callRate: 'Call Rate',
    callRecord: 'Call Records',
    wechatNum: 'WeChat Adds',
    wechatTarget: 'WeChat Add Target',
    wechatRate: 'WeChat Add Rate',
    wechatRecord: 'WeChat Add Records',
    commitmentNum: 'Scheduled Visits',
    commitmentTarget: 'Scheduled Visit Target',
    commitmentRate: 'Scheduled Visit Rate',
    commitmentRecord: 'Scheduled Visit Records',
    instoreNum: 'Visits',
    instoreTarget: 'Visit Target',
    instoreRate: 'Visit Rate',
    instoreRecord: 'Visit Records',
    orderNum: 'Closed Deals',
    orderTarget: 'Deal Target',
    orderRecord: 'Deal Records',
    conversionRate: 'Conversion Rate',
    orderDetail: 'Deal Details',
    orderType: 'Deal Type',
    view: 'View',
    selectMonth: 'Select Month',
    learningMachineSupervisor: 'Learning Tablet - Instructor',
    learningMachine: 'Learning Tablet',
    supervisor: 'Instructor',
    snCode: 'SN Code',
    learningMachineModel: 'Learning Tablet Model',
    adaptiveAccount: 'Adaptive Learning Account',
    orderAmount: 'Deal Amount',
    orderSplit: 'Order Allocation',
    splitDetail: 'Allocation Details',
    credential: 'Proof',
    noCredential: 'No Proof Available',
    close: 'Close',
    person: 'Person',
    splitRate: 'Allocation Rate',
    clueName: 'Lead Name',
    cluePhone: 'Lead Phone',
    clueSource: 'Lead Source',
    followUploadTime: 'Follow-up Upload Time',
    credentialDetail: 'Proof Details',
    descCredential: 'Description / Proof',
    collabSplit: 'Collaborative Allocation',
    record: 'Records',
    dailySummary: 'Daily Summary',
    processOutcomeExport: 'Export Process Metrics',
    resultOutcomeExport: 'Export Outcome Metrics',
    todayWorkContent: "Today's Work:",
    deleteSuccess: 'Deleted successfully',
  },
}
